var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5047 19.7917L17.508 21.875L21.5143 17.7083M13.5015 3.125H8.69383C7.57194 3.125 7.01099 3.125 6.58248 3.35207C6.20554 3.5518 5.89909 3.87051 5.70704 4.26252C5.48871 4.70817 5.48871 5.29156 5.48871 6.45833V18.5417C5.48871 19.7084 5.48871 20.2919 5.70704 20.7375C5.89909 21.1295 6.20554 21.4482 6.58248 21.6479C7.01099 21.875 7.57194 21.875 8.69383 21.875H11.9991M13.5015 3.125L19.5112 9.375M13.5015 3.125V7.70833C13.5015 8.29172 13.5015 8.58342 13.6107 8.80624C13.7067 9.00224 13.8599 9.16159 14.0484 9.26147C14.2626 9.375 14.5431 9.375 15.1041 9.375H19.5112M19.5112 9.375V13.9583M9.49512 17.7083H11.9991M9.49512 13.5417H15.5047M9.49512 9.375H10.4967",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForm);
export default __webpack_public_path__ + "static/media/form.4453c532302ca123b1c9d6ba7edf253b.svg";
export { ForwardRef as ReactComponent };